import hrithiq from "../assets/board/hrithiq.png";
import akshat from "../assets/board/akshatt.png";
import riya from "../assets/board/riya.jpg";
import tausif from "../assets/board/Tausif.png";
import sinha from "../assets/board/sinhaa.png";
import kashyap from "../assets/board/kashyap.jpg";
import anshul from "../assets/board/Anshull.jpeg";
import hitansh from "../assets/board/hitnashh.jpg";
import aryan from "../assets/board/aryan.png";
import sandeep from "../assets/board/sandeep.png";
import prakhar from "../assets/board/prakhar.png";
import yashika from "../assets/board/yashika.jpg";
import annanya from "../assets/board/Annanya.png";


const Team = {
	board: [
		{
			name: "Hrithiq Gupta",
			pos: "Chairperson and ML Head",
			gh: "",
			li: "https://www.linkedin.com/in/hrithiq-gupta",
			image: hrithiq,
			dr: "",
			quote: "Don't wish it were easier, wish you were better.",
		},
		{
			name: "Akshat Pandey",
			pos: "Vice Chairperson",
			gh: "",
			li: "https://in.linkedin.com/in/its-akshat-pandey",
			image: akshat,
			dr: "",
			quote: "Hope and despair are one and the same.",
		},
		{
			name: "Riya Agarwal",
			pos: "General Secretary",
			gh: "",
			li: "https://www.linkedin.com/in/riya-agarwal-2b304b2b3",
			image: riya,
			dr: "",
			quote: "nothing changes if nothing changes",
		},
		{
			name: "Mohammad Tausif",
			pos: "Treasurer and App Dev Head",
			gh: "",
			li: "https://www.linkedin.com/in/mohammad-tausif-3a50801a8/",
			image: tausif,
			dr: "",
			quote: "It will all make sense in the end",
		},
		{
			name: "Anshull Shukla",
			pos: "Dev Head",
			gh: "",
			li: "https://www.linkedin.com/in/anshul-shukla-aa81692a5/",
			image: anshul,
			dr: "",
			quote: "Jack of all trades master of none, though oftentimes better than master of one",
		},
		{
			name: "Hitansh Agarwal",
			pos: "Design Head",
			gh: "",
			li: "https://www.linkedin.com/in/hitansh-agarwal-98572b204/",
			image: hitansh,
			dr: "",
			quote: "If outside is so good, why has mankind spent thousands of years trying to perfect inside?",
		},
		{
			name: "Aryan Vivek",
			pos: "Tech Head and Project Head",
			gh: "",
			li: "https://www.linkedin.com/in/aryan-v-53a772284",
			image: aryan,
			dr: "",
			quote: "Roonil03",
		},
		{
			name: "Aditya Sinha",
			pos: "Tech Head",
			gh: "",
			li: "https://www.linkedin.com/in/aditya-sinha850/",
			image: sinha,
			dr: "",
			quote: "Choices are consequences, shaped by history and chemistry.",
		},
		{
			name: "Sandeep Balaji",
			pos: "ML Head",
			gh: "",
			li: "https://www.linkedin.com/in/sandeepb3008",
			image: sandeep,
			dr: "",
			quote: "Life is small. Smile while you still have teeth.",
		},
		{
			name: "Kashyap Dutta",
			pos: "Dev Head",
			gh: "",
			li: "https://www.linkedin.com/in/kashyap-datta-b19b50296/",
			image: kashyap,
			dr: "",
			quote: ":)",
		},
		{
			name: "Prakhar Umrao",
			pos: "Project Head",
			gh: "",
			li: "https://www.linkedin.com/in/prakhar-umrao-647377273/",
			image: prakhar,
			dr: "",
			quote: "Get busy living , or get busy dying",
		},
		{
			name: "Yashika Agarwal",
			pos: "Publicity and Logistics Head",
			gh: "",
			li: "https://www.linkedin.com/in/yashika-agarwal-99a42131a/",
			image: yashika,
			dr: "",
			quote: "Do it for your future self",
		},
		{
			name: "Annanya Tayal",
			pos: "Head of Human Resources",
			gh: "",
			li: "https://www.linkedin.com/in/annanya-tayal-055948287/",
			image: annanya,
			dr: "",
			quote: "Don’t survive. Choose to live.",
		}
	],


	"mancomm": [
    "Aadhar Sofat",
    "Aadya Chhavi Mishra",
    "Aarush Arora",
    "Aayush Inamdar",
    "Aayush Kumar Singh",
    "Abhyuday Gupta",
    "Adarsh P Nayak",
    "Adarsh yerneni",
    "Adi Shree",
    "Aditi Narsaria",
    "Aditya",
    "Aditya Jain",
    "Aditya Ranka",
    "Aditya Srivastava",
    "Advita Shrivastava",
    "Agrim Majmudar",
    "Aishwarya Singh",
    "Akanksh N Mallya",
    "Aman Anand",
    "Angela Chaudhuri",
    "Aniket singh chahar",
    "Aniketh Arunkumar",
    "Anivi Nama",
    "Anshul Das",
    "Anumit Bajpai",
    "Apoorva Ghadge",
    "Apoorva R",
    "Arnav Gandotra",
    "Arunima Bhattacharjee",
    "Aryaman Singh",
    "Athul John Asish",
    "Atisha Ariga",
    "Atulya Ishan",
    "Avantika Bhattacharya",
    "Aviral Nigam",
    "Bhuvi Sanga",
    "Chetanya Arora",
    "Chinmayi Upadhyay",
    "Danish Garg",
    "Dev Shah",
    "Devik Nangia",
    "Dhana Venkat Manikanta Sai Vignesh Thota",
    "Dhanya Karthikeyan",
    "Disha D Poojary",
    "Divyansh Santani",
    "Divyesh Shrivastava",
    "Diya Moogi",
    "Evanthe Gupta",
    "Giridhar Sreekumar",
    "Harshit Walia",
    "Hershel Shaun Menezes",
    "Hrit Singh",
    "Ishan Chowdhury",
    "Ishita Padhi",
    "Jenna Ann Sonali Sreshta Shetty",
    "Karan Kamath",
    "Karthik Pranav Dhulipala",
    "Kaustubha Saxena",
    "Kenneth Martin",
    "Khushi Nagelia",
    "Kodali Sri Surya Suhas",
    "Krapa D Vernekar",
    "Krishang Jain",
    "Krishiv Lall",
    "Kushal Raj",
    "Kyan agarwal",
    "Lahari V Kunder",
    "Lakshya Singhi",
    "Mahad Sheikh",
    "Mahika Kapil",
    "Mahira Srivastava",
    "Meenakshi Sangeeth",
    "mehran pratap singh dhakray",
    "Mitul Agrawal",
    "Navya Lakhotia",
    "Neelaksha",
    "Neha Varadharajan",
    "Nikita Mukta",
    "Nirav Chakrabarti",
    "Nishaanth S",
    "Om Raj",
    "Onas Chaturvedi",
    "P Sai Raghul",
    "Param Shah",
    "Parth Agrawal",
    "Parthiv Prasanth",
    "Pragati jain",
    "Praneeth N Naik",
    "Pranjli Aggarwal",
    "Prateek Vamana Pai",
    "Pratham Hemrajani",
    "Pratham Shah",
    "Praveen Kumar",
    "Prayatshu Misra",
    "Prisha Arora",
    "Prisha Binani",
    "Raahul Shenoy",
    "Ragini Gupta",
    "Rajrup Mal",
    "Rishabh Raj",
    "Rishit Singh",
    "Sai Harshith Reddy",
    "Samridhi Dhamija",
    "Sanshia Agarwal",
    "Sarah Kohli",
    "Sarthak Kaushik",
    "Sasmit",
    "Shashank Nandan",
    "Shaurya Jain",
    "Shlok Sandeep Kasargod",
    "Shlok Sharma",
    "Shravan S Rao",
    "Shreshth Kabra",
    "Shreyas B S",
    "Shrivas Manoj Shetty",
    "Siddarth N Shenoy",
    "Sudhiksha Shanbhag",
    "Taneesh S",
    "Tejas Srivastava",
    "Tirth Patel",
    "Tushyaansh Pal",
    "Vaibhav Bhatia",
    "Vaibhav S Nair",
    "Varda Murarka",
    "Vedang Pandey",
    "Vibha Bhat",
    "Vihaan Kharia",
    "Yashita Kotturi",
    "Yashovardhan Singh",
    "Yerramsetty Naga Vaishnavi"
  ]
};

export default Team;
